import React from 'react'
import { Tag } from 'lucide-react'

// Se llama como función: IconTag(true) es la variante del menú lateral (blanco translúcido sobre el
// color del cliente, como el resto de iconos del drawer); sin argumento, la de botones y tablas.
const Icon = (isNegative = false) =>
  isNegative === true ? <Tag size={20} color="white" opacity={0.6} /> : <Tag size={18} />

export default Icon
